module.exports = __webpack_public_path__ + "static/assets/3c31c71459cc3b556ea5e293dd1a8093.png";